<div class="switch-and-save-page">
    <section class="banner-section">
        <div class="banner-image-container">
            <div class="banner-img">
                <picture>
                    <source srcset='assets/img/banners/switch&save-banner-mobile.webp' media="(max-width: 639.9px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/switch&save-banner-mobile.png' media="(max-width: 639.9px)"
                        type="image/png">
                    <source srcset='assets/img/banners/switch&save-banner-tablet.webp' media="(max-width: 1024.9px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/switch&save-banner-tablet.png' media="(max-width: 1024.9px)"
                        type="image/png">
                    <source srcset='assets/img/banners/switch&save-banner-desktop.webp' media="(min-width: 1025px)"
                        type="image/webp">
                    <source srcset='assets/img/banners/switch&save-banner-desktop.png' media="(min-width: 1025px)"
                        type="image/png">
                    <img src="assets/img/banners/switch&save-banner-desktop.png" alt="switch&save-banner-image">
                </picture>
            </div>
        </div>
        <div class="banner-text-content">
            <h1 class="header">Switch and Save</h1>
            <p class="sub-header">Keep your phone. Keep your number, or let it go and start fresh with us.</p>
            <div class="view-plans-button">
                <button class="button primary" (click)="goToPlans()">View Plans</button>
            </div>
        </div>
    </section>
    <section class="switch-save-content-section section-paddings">
        <div class="side-section first-col-bottom">
            <div class="details-part first-col-right">
                <h2 class="title">Our best price ever for unlimited wireless!</h2>
                <p class="description">Save up to 25% when subscribing to a 3-Month plan. Get 3-month intro offer at our
                    lowest price of $20/mo with unlimited talk and Text and 8GB of high Speed data.</p>
                <div class="learn-more-button">
                    <button class="button primary" (click)="goToPlanDetails(threeMonthPlan)">Learn more</button>
                </div>
            </div>
            <div class="image-part">
                <picture>
                    <source srcset='assets/img/s&s-girl-with-phone-mobile.webp' media="(max-width: 639.9px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-girl-with-phone-mobile.png' media="(max-width: 639.9px)"
                        type="image/png">
                    <source srcset='assets/img/s&s-girl-with-phone-tablet.webp' media="(max-width: 1024.9px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-girl-with-phone-tablet.png' media="(max-width: 1024.9px)"
                        type="image/png">
                    <source srcset='assets/img/s&s-girl-with-phone-desktop.webp' media="(min-width: 1025px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-girl-with-phone-desktop.png' media="(min-width: 1025px)"
                        type="image/png">
                    <img src="assets/img/s&s-girl-with-phone-desktop.png" alt="switch-save-girl-with-phone-image">
                </picture>
            </div>
        </div>
        <div class="side-section column-reverse">
            <div class="image-part first-col-right">
                <picture>
                    <source srcset='assets/img/s&s-elderly-with-phone-mobile.webp' media="(max-width: 639.9px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-elderly-with-phone-mobile.png' media="(max-width: 639.9px)"
                        type="image/png">
                    <source srcset='assets/img/s&s-elderly-with-phone-tablet.webp' media="(max-width: 1024.9px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-elderly-with-phone-tablet.png' media="(max-width: 1024.9px)"
                        type="image/png">
                    <source srcset='assets/img/s&s-elderly-with-phone-desktop.webp' media="(min-width: 1025px)"
                        type="image/webp">
                    <source srcset='assets/img/s&s-elderly-with-phone-desktop.png' media="(min-width: 1025px)"
                        type="image/png">
                    <img src="assets/img/s&s-elderly-with-phone-desktop.png" alt="switch-save-elderly-with-phone-image">
                </picture>
            </div>
            <div class="details-part">
                <h2 class="title">Switching is simple</h2>
                <div class="description list-tablet">
                    <ul>
                        <div class="list-part">
                            <li><span>Keep your phone or buy a new one</span></li>
                            <li><span>Keep your number</span></li>
                        </div>
                        <div>
                            <li><span>Transfer without a contract</span></li>
                            <li><span>Free SIM card and Free shipping</span></li>
                        </div>
                    </ul>
                </div>
                <div class="learn-more-button">
                    <button class="button primary" (click)="goToPlans()">Get started</button>
                </div>
            </div>
        </div>
    </section>
    <section class="check-phone-section section-paddings">
        <h2 class="title">Bring The Phone You Already Own & Love</h2>
        <p class="description">Bring the phone you already own and love. Most phones work on our network. Let’s confirm
            if yours is compatible with one of the largest networks in the United States.</p>
        <button class="button primary" (click)="checkYourPhone()">Check your phone</button>
    </section>

    <section class="tabs-section section-paddings">
        <h2 class="title">Choose on America’s best network</h2>
        <p class="sub-title">Best network based on GWS OneScore Sept. 2019.</p>
        <div class="features">
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/5g-icon.svg" alt="5G" /></div>
                <div class="title-row">
                    <h5 class="title">BLAZING FAST 5G Network</h5>
                </div>
                <div class="details-row">
                    <p class="details shorter">Our service runs on the best Network available.</p>
                </div>
            </div>
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/s&s-wifi-calling.svg" alt="wifi calling" /></div>
                <div class="title-row">
                    <h5 class="title">UNLIMITED TALK & TEXT</h5>
                </div>
                <div class="details-row">
                    <p class="details medium">Enjoy our unlimited talking minutes and text messages.</p>
                </div>
            </div>
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/s&s-Wifi-signals.svg" alt="Wifi signals" /></div>
                <div class="title-row">
                    <h5 class="title">WiFi Calling</h5>
                </div>
                <div class="details-row">
                    <p class="details">Call or message virtually anyone from anywhere you have a Wi-Fi connection, from
                        the U.S. and from most international countries.</p>
                </div>
            </div>
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/s&s-phone.svg" alt="phone" /></div>
                <div class="title-row">
                    <h5 class="title">HD VOICE</h5>
                </div>
                <div class="details-row">
                    <p class="details">Enjoy calls that sound like you’re having a conversation with someone in the same
                        room instead of across the country.</p>
                </div>
            </div>
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/byod-sim-card.svg" alt="Free SIM" /></div>
                <div class="title-row">
                    <h5 class="title">FREE SIM CARD & FREE SHIPPING</h5>
                </div>
                <div class="details-row">
                    <p class="details short">Choose one of our unlimited data plans and get a free SIM card + free
                        shipping.</p>
                </div>
            </div>
            <div class="reason-card">
                <div class="icon"><img src="assets/icon/global-calling-icon.svg" alt="Global calling" /></div>
                <div class="title-row">
                    <h5 class="title">FREE INTERNATIONAL CALLING</h5>
                </div>
                <div class="details-row">
                    <p class="details">FREE calling to Mexico, Canada and to over 150+ destinations.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="faqs-section section-paddings">
        <h2 class="header">FAQs to help you get started</h2>
                    <div class="questions">
                        <div *ngFor="let qst of firstThreeQuestions">
                            <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
                                [class.active]="qst?.fields?.questionId == questionId"
                                [isActive]="qst?.fields?.questionId == questionId"
                                (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                            </app-question-answer>
                        </div>
                        <div *ngIf="!!showMore">
                            <div *ngFor="let qst of restQuestions">
                                <app-question-answer question="{{qst?.fields?.questionText}}"
                                    [id]="qst?.fields?.questionId"
                                    [class.active]="qst?.fields?.questionId == questionId"
                                    [isActive]="qst?.fields?.questionId == questionId"
                                    (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
                                    <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
                                </app-question-answer>
                            </div>
                        </div>
                        <div class="border"></div>
                    </div>

        <p class="more-or-less-faqs" *ngIf="!showMore"><a (click)="showMore = true">More FAQs</a></p>
        <p class="more-or-less-faqs" *ngIf="!!showMore"><a (click)="showMore = false; questionId = 'q0'">Less FAQs</a>
        </p>
        <div class="switch-save-info">
            <p class="description1">Most unlocked GSM phones will work on the FreeUp network, however, we don’t have
                control over the availability of the features we provide that are not available from your unlocked
                phone. Unfortunately, some features like Wi-Fi calling, VoLTE, MMS may not work on our network. FreeUP
                Mobile cannot and does not guarantee the functionality or performance of any handsets or devices for use
                on the FreeUP Mobile network. Nor do we guarantee the functionality of any handsets or devices. As a
                courtesy, we provide Internet and picture messaging (MMS) settings for some devices. FreeUP Mobile
                cannot guarantee the effectiveness of these settings, nor their placement in the device and therefore
                does not assume any liability for the lack of effectiveness of these settings for the devices.</p>
            <p class="description2">Wi-Fi Calling requires Wi-Fi Calling capable smartphone and Wi-Fi network. Once
                enabled, phone automatically makes/receives calls/text messages over Wi-Fi in the U.S. If wireless
                network coverage is weak or unavailable, or outside the Domestic Coverage Area anytime you connect to a
                Wi-Fi network. Wi-Fi Calling is available on select devices. Use of Wi-Fi Calling may be restricted in
                some countries. If you move in or out of Wi-Fi coverage while on a Wi-Fi call, your call will disconnect
                unless you have AT&T HD Voice coverage (911 calls will disconnect even if you are within HD Voice
                coverage). HD Voice not available everywhere. To enable Wi-Fi Calling, you must have a wireless account
                provisioned for HD Voice. Cannot use Wi-Fi Calling to call 211, 311, 511, and 811. <a
                    [routerLink]="[SUPPORT_ROUTE_URLS.BASE + '/'+SUPPORT_ROUTE_URLS.FAQS + '/wifi-calling']">Learn
                    more</a>.</p>
        </div>
    </section>
</div>